// Container max-widths. Use `prose` for documentation surfaces, `app`
// for product pages, `marketing` for landing / hero blocks, `full` for
// dashboards that genuinely benefit from horizontal real estate.
export const container = {
  prose: 680,
  app: 1040,
  marketing: 1280,
  full: 1680,
} as const;
